const referFilters = {
  handleFilterParams: (filterConditions, conditionIsNull, condition, referContext) => {
    let conditions;
    if (Array.isArray(filterConditions)) { // 兼容旧数据
      conditions = referFilters.getFilterConditions(filterConditions, referContext)
      if (conditionIsNull) { // 无值不过滤
        conditions = conditions.filter(item => item.value1 !== '' && item.value1 !== undefined && item.value1 !== null)
      }
    } else { // 新协议-或连接符
      if (filterConditions.children) {
        conditions = [referFilters.getConditions(filterConditions, referContext)]
      } else {
        conditions = []
      }
    }
    if (condition && condition.simpleVOs) condition.simpleVOs.push(...conditions)
    else condition = { isExtend: true, simpleVOs: [...conditions] }
   return condition;
  },
  // 参照过滤(旧协议)
  getFilterConditions: (filterConditions, referContext) => {
    return filterConditions.map(item => {
      // 0:公式表达式 1:字段 2:常量
      if (item.conditionType === 2) { // 常量
        let v = ''
        if (item.conditionValueType === 'Object') { // 参照值, 对象
          v = JSON.parse(item.conditionValue)[0][referContext.metaDataObj.cEntityKeyFld]
        } else { // 参照以外其他的值
          v = item.conditionValue;
        }
        return { field: item.conditionKey, op: item.compareLogic, value1: v }
      } else if (item.conditionType === 1) { // 字段
        let _modelpath = item.conditionValue.split(',');
        let storeField = _modelpath[_modelpath.length - 1] || '';
        let temObj = referContext.props.pageStore.rootStore || {};
        let _value1 = ''
        if (temObj.storeType === "FilterStore") {
          _value1 = temObj[_modelpath[0]]?.getFilterItemByName(storeField).getQueryValue().v1
        } else {
          _value1 = temObj[_modelpath[0]]?.getValue(storeField)
        }
        return { field: item.conditionKey, op: item.compareLogic, value1: _value1 }
      }
    })
  },
  // 递归遍历参照过滤
  getConditions: (obj, referContext) => {
    const cEntityKeyFld = referContext.metaDataObj.cEntityKeyFld || 'id';
    let logicOp = ''
    let conditions = obj.children.map((item, index) => {
      if (item.isLeaf === false) {
        return referFilters.getConditions(item, referContext)
      }
      logicOp = item.relationType
      // 0:公式表达式 1:字段 2:常量 
      if (item.conditionType === 2) { // 常量
        let v = ''
        if (item.conditionValueType === 'Object') { // 参照值, 对象
          let vobj = {}
          try {
            vobj = JSON.parse(item.conditionValue);
          } catch {
            vobj = item.conditionValue
          }
          if (Array.isArray(vobj)) {
            v = vobj[0][cEntityKeyFld]
          } else {
            v = vobj[cEntityKeyFld]
          }
        } else { // 参照以外其他的值
          v = item.conditionValue;
        }
        return { field: item.conditionKey, op: item.compareLogic, value1: v }
      } else if (item.conditionType === 1) { // 字段 格式为 "mobx://rootStore.formStore,orgId"
        let storePath = item.conditionValue.replace('mobx://rootStore.', '');
        let storeField = storePath.split(',')[1]
        storePath = storePath.split(',')[0]
        let storePathArr = storePath.split('.')
        let temObj = referContext.props.pageStore.rootStore || {};
        storePathArr.map(item => {
          temObj = temObj[item];
        })
        let _value1 = ''
        if (temObj.storeType === "FilterStore") {
          _value1 = temObj?.getFilterItemByName(storeField).getQueryValue().v1
        } else if (temObj.storeType === "TableStore") {
          const filed = temObj.getColumn(storeField)?.getField();
          _value1 = temObj.getRowByKey(temObj.currentActiveRowKey).getTrueValue(filed);
        } else {
          _value1 = temObj?.getValue(storeField)
        }
        return { field: item.conditionKey, op: item.compareLogic, value1: _value1 }
      }
    })
    const { conditionIsNull } = referContext.props;
    if (conditionIsNull) { // 无值不过滤
      conditions = conditions.filter(item => item.value1 !== '' && item.value1 !== undefined && item.value1 !== null)
    }
    if (!logicOp && obj.logicMap) {
      if (obj.logicMap === '&&') {
        logicOp = 'and'
      } else if (obj.logicMap === '||') {
        logicOp = 'or'
      }
    }
    return {
      logicOp,
      conditions
    }
  },

  // 精准搜索
  getExactQuery: (referContext, searchKey) => {
    let arr = referContext.metaDataObj.cCheckFlds.split(',')
    let conditions = arr.map(item => {
      return { field: item, op: "eq", value1: searchKey }
    })
    return { isExtend: true, simpleVOs: [{ logicOp: "or", conditions }] }
  },

  // 显示停用
  getStopStatus: (condition, stopStatus) => {
    if (condition && condition.simpleVOs) {
      condition.simpleVOs.push({ field: "stopstatus", op: "in", value1: stopStatus ? [1, 0] : [0] })
    } else {
      condition = {
        isExtend: true,
        isRefreshData: true,
        simpleVOs: [{ field: "stopstatus", op: "in", value1: stopStatus ? [1, 0] : [0] }]
      }
    }
      return condition
    }
}

export default referFilters
